import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { Button } from "../ui/button";

const WHATSAPP_LINK = "https://wa.me/919866679191?text=Hi%2C%20I%27m%20interested%20in%20your%20paint%20services";
const SHOP_LOGO = "https://customer-assets.emergentagent.com/job_sri-paint-studio/artifacts/chy8ekpj_image.png";

const navLinks = [
  { name: "Home", href: "#home" },
  { name: "About", href: "#about" },
  { name: "Products", href: "#products" },
  { name: "Solutions", href: "#solutions" },
  { name: "Partners", href: "#partners" },
  { name: "Gallery", href: "#gallery" },
  { name: "Contact", href: "#contact" }
];

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? "glass shadow-sm" : "bg-white/95"
        }`}
        data-testid="main-navigation"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="flex items-center justify-between h-16 sm:h-20">
            <a href="#home" className="flex items-center" data-testid="logo-link">
              <img 
                src={SHOP_LOGO} 
                alt="Sri Pavanasutha Traders" 
                className="h-10 sm:h-12 w-auto object-contain"
              />
            </a>

            <div className="hidden lg:flex items-center gap-6 xl:gap-8">
              {navLinks.map((link) => (
                <a key={link.name} href={link.href} className="nav-link text-sm" data-testid={`nav-${link.name.toLowerCase()}`}>
                  {link.name}
                </a>
              ))}
            </div>

            <div className="hidden lg:block">
              <Button asChild className="bg-purple-600 hover:bg-purple-700 text-white px-5 py-2 rounded-full font-medium shadow-md" data-testid="nav-cta-button">
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
                  <Phone className="w-4 h-4 mr-2" />
                  Get Quote
                </a>
              </Button>
            </div>

            <button className="lg:hidden p-2 -mr-2" onClick={() => setMobileMenuOpen(true)} data-testid="mobile-menu-button">
              <Menu className="w-6 h-6 text-gray-700" />
            </button>
          </div>
        </div>
      </motion.nav>

      <div className={`mobile-menu-overlay ${mobileMenuOpen ? "open" : ""}`} onClick={() => setMobileMenuOpen(false)} />

      <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`} data-testid="mobile-menu">
        <div className="p-5">
          <div className="flex justify-between items-center mb-6">
            <img src={SHOP_LOGO} alt="Logo" className="h-10" />
            <button onClick={() => setMobileMenuOpen(false)} data-testid="close-mobile-menu" className="p-1">
              <X className="w-6 h-6 text-gray-600" />
            </button>
          </div>
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a 
                key={link.name} 
                href={link.href} 
                className="text-base font-medium text-gray-700 hover:text-purple-600 py-3 border-b border-gray-100" 
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <a 
              href={WHATSAPP_LINK} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="mt-4 bg-purple-600 text-white text-center py-3 rounded-full font-medium"
            >
              <Phone className="w-4 h-4 inline mr-2" />
              Get Quote on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
